<template>
  <j-modal
    :title="title"
    width="45%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '500px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('名称')" prop="name">
                <a-input v-model="model.name" :placeholder="$t('请输入名称')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-input v-model="model.remark" :placeholder="$t('请输入备注')"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item>
                <a-button type="primary" icon="plus" @click="handleAdd">{{ $t('添加') }}</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-table
                ref="table"
                size="middle"
                :scroll="{ x: 800 }"
                bordered
                rowKey="id"
                :columns="columns"
                :dataSource="model.customizeConfigDataList"
                :pagination="false"
                class="j-table-force-nowrap"
              >
                <template slot-scope="text, record, index" slot="minLimit">
                  <a-form-model-item>
                    <template v-if="index != 0">
                      <a-input-number
                        v-model="record.minLimit"
                        :placeholder="$t('请输入流速下限')"
                        style="width: 100%"
                      ></a-input-number>
                    </template>
                  </a-form-model-item>
                </template>
                <template slot="range">
                  <a-form-model-item>
                    <span> < </span>
                  </a-form-model-item>
                </template>
                <template slot-scope="text, record, index" slot="maxLimit">
                  <a-form-model-item>
                    <template v-if="index != model.customizeConfigDataList.length - 1">
                      <a-input-number
                        v-model="record.maxLimit"
                        :placeholder="$t('请输入流速上限')"
                        style="width: 100%"
                      ></a-input-number>
                    </template>
                  </a-form-model-item>
                </template>
                <template slot-scope="text, record" slot="lineWidth">
                  <a-form-model-item>
                    <a-input-number
                      v-model="record.lineWidth"
                      :placeholder="$t('请输入线宽')"
                      style="width: 100%"
                    ></a-input-number>
                  </a-form-model-item>
                </template>
                <template slot-scope="text, record" slot="colour">
                  <a-form-model-item>
                    <el-color-picker v-model="record.colour" size="small"></el-color-picker>
                  </a-form-model-item>
                </template>
                <template slot-scope="text, record, index" slot="action">
                  <a
                    @click="handleDelete(index)"
                    :disabled="index == 0 || index == model.customizeConfigDataList.length - 1"
                    >{{ $t('删除') }}</a
                  >
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
export default {
  name: 'modal',
  components: {},
  data() {
    return {
      title: this.$t('管径渲染配置'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      url: {
        createCustomizeConfigScheme: '/jeecg-gis/customizeConfigScheme/createCustomizeConfigScheme',
        editCustomizeConfigScheme: '/jeecg-gis/customizeConfigScheme/editCustomizeConfigScheme',
      },
    }
  },
  computed: {
    validatorRules() {
      return {
        name: [{ required: true, message: this.$t('请输入名称') }],
        remark: [{ required: true, message: this.$t('请输入备注') }],
      }
    },
    columns() {
      return [
        {
          title: this.$t('流速下限'),
          dataIndex: 'minLimit',
          align: 'center',
          scopedSlots: { customRender: 'minLimit' },
        },
        {
          title: ' ',
          dataIndex: 'range',
          align: 'center',
          width: 50,
          scopedSlots: { customRender: 'range' },
        },
        {
          title: this.$t('流速上限'),
          dataIndex: 'maxLimit',
          align: 'center',
          scopedSlots: { customRender: 'maxLimit' },
        },
        {
          title: this.$t('线宽'),
          dataIndex: 'lineWidth',
          align: 'center',
          scopedSlots: { customRender: 'lineWidth' },
        },
        {
          title: this.$t('颜色'),
          dataIndex: 'colour',
          align: 'center',
          scopedSlots: { customRender: 'colour' },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    edit(row) {
      this.visible = true
      if (row.customizeConfigScheme.id) {
        this.model = Object.assign({}, row, {
          name: row.customizeConfigScheme.name,
          remark: row.customizeConfigScheme.remark,
        })
      } else {
        this.model = Object.assign({}, row, {
          customizeConfigDataList: [
            { nodeType: 'NODE_PIPELINE_TYPE_PIPELINE', minLimit: '', maxLimit: '', lineWidth: '', colour: '' },
            {
              nodeType: 'NODE_PIPELINE_TYPE_PIPELINE',
              minLimit: '',
              maxLimit: '',
              lineWidth: '',
              colour: '',
            },
          ],
        })
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let url = ''
          let message = ''
          let params = {
            customizeConfigScheme: {},
            customizeConfigDataList: this.model.customizeConfigDataList,
          }
          if (this.model.customizeConfigScheme.id) {
            url = this.url.editCustomizeConfigScheme
            message = this.$t('编辑成功！')
            params.customizeConfigScheme = {
              id: this.model.customizeConfigScheme.id,
              projectCode: this.model.customizeConfigScheme.projectCode,
              name: this.model.name,
              remark: this.model.remark,
              customizeType: this.model.customizeConfigScheme.customizeType,
            }
          } else {
            url = this.url.createCustomizeConfigScheme
            message = this.$t('新增成功！')
            params.customizeConfigScheme = {
              projectCode: this.model.customizeConfigScheme.projectCode,
              name: this.model.name,
              remark: this.model.remark,
              customizeType: this.model.customizeConfigScheme.customizeType,
            }
          }
          postAction(url, params)
            .then(res => {
              if (res.success) {
                that.$message.success(message)
                that.$emit('ok', this.model)
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    handleAdd() {
      this.model.customizeConfigDataList.splice(this.model.customizeConfigDataList.length - 1, 0, {
        nodeType: 'NODE_PIPELINE_TYPE_PIPELINE',
        minLimit: '',
        maxLimit: '',
        lineWidth: '',
        colour: '',
      })
    },
    handleDelete(index) {
      this.model.customizeConfigDataList.splice(index, 1)
    },
  },
}
</script>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
